import { useCallback } from "react";
import { generatePluralText } from "./useTeachings.js";
import { useBannerOrBlocker } from "../useBannerOrBlocker.js";
function useDurationText() {
    const { i18n: { durationUnit: durationUnitTexts } } = useBannerOrBlocker();
    return useCallback((duration, unit)=>generatePluralText(duration, durationUnitTexts["n1"][unit], durationUnitTexts["nx"][unit]), [
        durationUnitTexts
    ]);
}
export { useDurationText };
